import UIComponent from "../../common/UIComponent";
import "./index.css";
export default class SpeedBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.Lang = interfaces.language;
    this.speedMap = new Map();
    this.speedKeys = [];
    this.init();
  }

  init() {
    this.speedComponent = document.createElement("div");
    this.speedComponent.setAttribute("class", "vhallPlayer-speed-component");
    this.speedComponent.onmouseleave = this.handleComponentMouseLeave.bind(this);

    this.speedBtn = document.createElement("span");
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn");
    this.speedBtn.innerText = `1.0x`;

    this.speedBtn.onclick = this.handleBtnClick.bind(this);


    this.speedListPopup = document.createElement("div");
    this.speedListPopup.setAttribute("class", "speed-popup");

    // this.speedListTitle = document.createElement("div");
    // this.speedListTitle.setAttribute("class", "vhallPlayer-speedTitle");
    // this.speedListTitle.innerText = this.Lang.speed.title;


    this.speedListBox = document.createElement("ul");
    this.speedListBox.setAttribute("class", "speed-list-box");


    // this.speedListBox.appendChild(this.speedListTitle);

    for (let i = 0; i < this.interfaces.getUsableSpeed().filter(item => { return item < 3 }).length; i++) {
      const value = this.interfaces.getUsableSpeed().filter(item => { return item < 3 })[i];
      // switch (value) {
      //   case 1:
      //     this.speedMap.set(this.Lang.speed.normal, value);
      //     this.speedKeys.push(this.Lang.speed.normal);
      //     break;
      //   default:
      //     this.speedMap.set(`${value}x`, value);
      //     this.speedKeys.push(`${value}x`);
      //     break;
      // }
      if(value === 1 || value === 2){
        this.speedMap.set(`${value.toFixed(1)}x`, value);
        this.speedKeys.push(`${value.toFixed(1)}x`);
        continue;
      }
      this.speedMap.set(`${value}x`, value);
      this.speedKeys.push(`${value}x`);
    }


    for (let i = 0; i < this.speedKeys.length; i++) {
      const key = this.speedKeys[i];
      this.speedItem = document.createElement("li");
      this.speedItem.onclick = this.handleItemClick.bind(this);
      this.speedItem.innerText = key;
      key === `1.0x` ? this.speedItem.classList.add("active") : undefined;
      this.speedListBox.appendChild(this.speedItem);
    }


    this.speedListPopup.appendChild(this.speedListBox);

    this.speedComponent.appendChild(this.speedBtn);
    this.speedComponent.appendChild(this.speedListPopup);
    this.insertElement(this.elementId, this.speedComponent);
  }


  handleComponentMouseLeave() {
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn")
    this.speedListPopup.style.display = "none";
    // this.speedListPopup.style.opacity = "0";
  }

  handleBtnClick() {
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn active")
    this.speedListPopup.style.display = "block";
    // this.speedListPopup.style.opacity = "1";
  }

  handleItemClick(event) {
    for (let i = 0; i < document.querySelectorAll(".speed-list-box li").length; i++) {
      const value = document.querySelectorAll(".speed-list-box li")[i];
      value.removeAttribute("class");
    }
    // document.querySelectorAll(".speed-list-box li").forEach(value => {
    //   value.removeAttribute("class");
    // });
    event.target.classList.add("active");
    const value = event.target.innerText;
    this.speedBtn.innerText = value;
    this.speedBtn.setAttribute("class", "vhallPlayer-speedBtn")
    this.speedListPopup.style.display = "none";
    // this.speedListPopup.style.opacity = "0";

    this.interfaces.setPlaySpeed(this.speedMap.get(value));
  }
}